import { useZero } from "@rocicorp/zero/react";
import { useCallback, useEffect } from "react";
import { sharedMutators } from "../../shared/mutators";
import { useFeatureFlag } from "./useFeatureFlag";

const presenceHeartbeatMs = 2_000;

export function useSetPresence(
  workflowId: string,
  branchId?: string,
  stepDir?: string
) {
  const z = useZero();
  const disabled = useFeatureFlag("disable-touch-presence");

  const setPresence = useCallback(() => {
    if (disabled || !branchId || document.hidden) return;
    z.mutate(sharedMutators.touchPresence({ workflowId, branchId, stepDir }));
  }, [z, workflowId, branchId, stepDir, disabled]);

  useEffect(() => {
    setPresence();
    const id = window.setInterval(setPresence, presenceHeartbeatMs);
    return () => window.clearInterval(id);
  }, [setPresence]);

  useEffect(() => {
    document.addEventListener("visibilitychange", setPresence);
    return () => document.removeEventListener("visibilitychange", setPresence);
  }, [setPresence]);
}
